import React, { useState, useEffect } from 'react';
import { IoArrowForwardOutline } from "react-icons/io5";
import { useTranslation } from 'react-i18next';
import SubpageBanner from '../components/SubpageBanner';
import api from '../services/api';

export default function News() {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState('haberler');
    const [newsData, setNewsData] = useState([]);
    const [announcementsData, setAnnouncementsData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Tarih formatlama fonksiyonu
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('tr-TR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    // Cointelegraph'dan RSS feed'i çek
    const fetchRSSFeed = async () => {
        try {
            console.log('RSS feed çekiliyor...');
            
            // Backend API'den RSS feed'i çek
            const response = await api.getRSSFeed();
            
            console.log('RSS API Response:', response);
            
            if (!response.success || !response.data) {
                console.warn('RSS feed alınamadı', response);
                return [];
            }

            const xmlText = response.data;
            console.log('XML uzunluğu:', xmlText.length);
            
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(xmlText, 'text/xml');

            // Parse hatalarını kontrol et
            const parserError = xmlDoc.querySelector('parsererror');
            if (parserError) {
                console.error('XML parse hatası:', parserError.textContent);
                return [];
            }

            const items = xmlDoc.querySelectorAll('item');
            console.log('Bulunan item sayısı:', items.length);
            
            if (items.length === 0) {
                console.warn('RSS feed\'de haber bulunamadı');
                return [];
            }

            const rssNews = Array.from(items).slice(0, 10).map((item, index) => {
                const title = item.querySelector('title')?.textContent || '';
                const linkElement = item.querySelector('link')?.textContent || '';
                const description = item.querySelector('description')?.textContent || '';
                const pubDate = item.querySelector('pubDate')?.textContent || '';
                const guid = item.querySelector('guid')?.textContent || '';

                // CDATA içinden link çıkar
                const link = linkElement.trim();

                // Açıklamadan HTML etiketlerini temizle
                const cleanDescription = description.replace(/<[^>]*>/g, '').trim();

                return {
                    id: `rss-${index}`,
                    title: title,
                    summary: cleanDescription.substring(0, 150) + (cleanDescription.length > 150 ? '...' : ''),
                    publishedAt: pubDate,
                    link: link,
                    guid: guid,
                    isExternalNews: true // RSS haberlerini tanımlamak için işaret
                };
            });

            console.log(`${rssNews.length} adet RSS haberi yüklendi`);
            console.log('İlk haber:', rssNews[0]);
            return rssNews;
        } catch (error) {
            console.error('RSS feed çekilirken hata oluştu:', error);
            return [];
        }
    };

    // Başlıktan URL dostu slug oluştur
    const createSlug = (title) => {
        // Türkçe karakter eşleştirmesi
        const turkishChars = {
            'ç': 'c', 'ğ': 'g', 'ı': 'i', 'ö': 'o', 'ş': 's', 'ü': 'u',
            'Ç': 'c', 'Ğ': 'g', 'İ': 'i', 'Ö': 'o', 'Ş': 's', 'Ü': 'u'
        };

        return title
            .toLowerCase()
            .replace(/[çğıöşüÇĞİÖŞÜ]/g, (char) => turkishChars[char] || char) // Türkçe karakterleri değiştir
            .replace(/[^a-z0-9\s-]/g, '') // Boşluk ve tire dışındaki özel karakterleri kaldır
            .replace(/\s+/g, '-') // Boşlukları tire ile değiştir
            .replace(/-+/g, '-') // Birden fazla tireyi tek tire ile değiştir
            .trim();
    };

    // Haber ve duyuru verilerini çek
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                setError(null);

                // RSS feed'i çek
                const rssNews = await fetchRSSFeed();
                
                // Duyuruları çek (hata verse bile devam et)
                let announcementsResponse = { success: false, data: [] };
                try {
                    announcementsResponse = await api.getAllAnnouncements();
                } catch (announcementErr) {
                    console.warn('Duyurular yüklenemedi:', announcementErr);
                }

                // RSS haberlerini kullan
                let combinedNews = [];
                
                // Varsa RSS haberlerini ekle
                if (rssNews && rssNews.length > 0) {
                    combinedNews = [...rssNews];
                }

                // Hala haber yoksa, mesaj göster
                if (combinedNews.length === 0) {
                    setError('Şu anda gösterilecek haber bulunmamaktadır.');
                }

                setNewsData(combinedNews);

                if (announcementsResponse.success && announcementsResponse.data) {
                    setAnnouncementsData(announcementsResponse.data);
                }
            } catch (err) {
                console.error('Error fetching data:', err);
                // RSS haberleri varsa hata gösterme
                setError('Veriler yüklenirken bir hata oluştu.');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);



    if (loading) {
        return (
            <>
                <SubpageBanner
                    title={t('news.title')}
                    page={t('news.page')}
                    path="/news"
                />
                <div className='news-content'>
                    <div className="container">
                        <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
                            <div className="text-center">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">{t('news.loading')}</span>
                                </div>
                                <p className="mt-3">{t('news.loadingNews')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <SubpageBanner
                title={t('news.title')}
                page={t('news.page')}
                path="/news"
            />
            <div className='news-content'>
                <div className='container'>
                    <div className='news-header'>
                        <div>
                            <h2 className='mb-2'>{activeTab === 'haberler' ? t('news.news') : t('news.announcements')}</h2>
                            <p className='news-subtitle'>{activeTab === 'haberler' ? t('news.explanation') : t('news.announcementsExplanation')}</p>
                        </div>
                        <ul className="nav news-tabs">
                            <li className="nav-item">
                                <button
                                    className={`nav-link${activeTab === 'haberler' ? ' active' : ''}`}
                                    onClick={() => setActiveTab('haberler')}
                                    type="button"
                                >
                                    {t('news.news')}
                                </button>
                            </li>
                            <li className="news-tab-separator">/</li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link${activeTab === 'duyurular' ? ' active' : ''}`}
                                    onClick={() => setActiveTab('duyurular')}
                                    type="button"
                                >
                                    {t('news.announcements')}
                                </button>
                            </li>
                        </ul>
                    </div>

                    <div className='news-body'>
                        {loading ? (
                            <div className='text-center py-4'>
                                <div className='spinner-border' role='status'>
                                    <span className='visually-hidden'>{t('news.loading')}</span>
                                </div>
                                <p className='mt-2'>{t('news.loadingNews')}</p>
                            </div>
                        ) : error ? (
                            <div className='text-center py-4'>
                                <p className='text-danger'>{error}</p>
                                <button
                                    className='btn btn-primary'
                                    onClick={() => window.location.reload()}
                                >
                                    {t('news.retry')}
                                </button>
                            </div>
                        ) : (
                            (activeTab === 'haberler' ? newsData : announcementsData).map((item, index) => (
                                <a
                                    key={`${activeTab}-${index}`}
                                    target={item.isExternalNews ? '_blank' : '_self'}
                                    rel={item.isExternalNews ? 'noopener noreferrer' : ''}
                                    href={item.isExternalNews ? item.link : (activeTab === 'haberler' ? `/news/${createSlug(item.title)}/${item.id}` : `/announcements/${createSlug(item.title)}/${item.id}`)}
                                    className='news-body-item d-flex align-items-center justify-content-between'
                                >
                                    <div>
                                        <h5 className='mb-1 news-title'>
                                            {item.title}
                                        </h5>
                                        <span className='news-summary'>
                                            {activeTab === 'haberler' ? formatDate(item.publishedAt) : formatDate(item.startDate)}
                                        </span>
                                        {activeTab === 'haberler' && item.summary && (
                                            <p className='mt-2 small' style={{ color: 'var(--muted)' }}>
                                                {item.summary}
                                            </p>
                                        )}
                                    </div>
                                    <div className='d-flex align-items-center'>
                                        <div className='ms-4 news-arrow'>
                                            <IoArrowForwardOutline size={22} />
                                        </div>
                                    </div>
                                </a>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}